import { AfterViewInit, Component, Input, OnDestroy, ViewChildren } from '@angular/core';
import { ActionPlanSubpanelConfigurations } from './action-plan-subpanel-configurations';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ActionPlanSubSubpanelComponent } from '../action-plan-sub-subpanel/action-plan-sub-subpanel.component';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-action-taxonomy-goal',
  templateUrl: './action-taxonomy-goal.component.html',
  styleUrls: ['./action-taxonomy-goal.component.scss'],
  standalone: true,
  imports: [ CommonModule, MatExpansionModule, ActionPlanSubSubpanelComponent, DynamicContentComponent, StripSpecialCharsPipe ]
})
export class ActionTaxonomyGoalComponent implements OnDestroy, AfterViewInit {

  parentOpenState = false;
  panelOpenState = false;

  @Input() config: ActionPlanSubpanelConfigurations;
  @Input() color: string;
  @Input() collapseChildren = false;
  @Input() categories: any[];
  @Input() columnNames: any[];
  @Input() columnsActive: any[];

  @ViewChildren(ActionPlanSubSubpanelComponent) subSubPanels: ActionPlanSubSubpanelComponent[];

  private _subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute
  ) {
  }

  handleOpened() {
    this.panelOpenState = true;
    this.subSubPanels.forEach(subPanel => {
      subPanel.handleParentOpened();
    });
  }

  handleClosed() {
    this.panelOpenState = false;
    this.subSubPanels.forEach(subPanel => {
      subPanel.handleParentClosed();
    });
  }


  ngAfterViewInit(): void {
    if (this.route.snapshot.queryParams.goal && StripSpecialCharsPipe.strip(this.config.title) === this.route.snapshot.queryParams.goal) {
      this.panelOpenState = true;
      this.scroll();
    }
    this._subscriptions.push(
      this.route.queryParams.subscribe(params => {
        if (params.goal && StripSpecialCharsPipe.strip(this.config.title) === params.goal) {
          this.panelOpenState = true;
          this.scroll();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  scroll() {
    const el = document.getElementById(`${StripSpecialCharsPipe.strip(this.config.title)}-goal`);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({
          block: 'center'
        });
      }, 400);
    }
  }

  handleParentOpened() {
    this.parentOpenState = true;
  }

  handleParentClosed() {
    this.parentOpenState = false;
    if (this.collapseChildren) {
      this.panelOpenState = false;
    }
  }
}
